import { render, staticRenderFns } from "./GoodManageLayout.vue?vue&type=template&id=761dea34&scoped=true"
import script from "./GoodManageLayout.vue?vue&type=script&lang=js"
export * from "./GoodManageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761dea34",
  null
  
)

export default component.exports